import * as Yup from "yup";

const step1FormSchema = Yup.object({
  profilePicUrl: Yup.string().required("Profile Picture required"),
  firstName: Yup.string()
    .min(2, "Must have minimum 2 characters")
    .required("First Name is required"),
  // middleName: Yup.string(),
  lastName: Yup.string()
    .min(2, "Must have minimum 2 characters")
    .required("Last Name is required"),
  // preferedLocation: Yup.string().required("Prefered Location is Required"),
  dob: Yup.date().required("Date of Birth is required"),
  gender: Yup.string().oneOf(["male", "female"]).required("Gender is required"),
  fatherName: Yup.string().required("Father's Name is required"),
  // aadharNumber: Yup.string().required("Aadhar number is required"),
  email: Yup.string()
    .email("Not a valid Email ID")
    .required("Email is required"),
  phoneNumber: Yup.string()
    .length(10, "Phone number should be 10 digits")
    .required("Phone number is required"),
  altNumber: Yup.string().length(10, "Phone number should be 10 digits"),
  address: Yup.string().required("Address is required"),
  city: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required("City is required")
    .nullable(),
  state: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required("State is required")
    .nullable(),
  pincode: Yup.string()
    .length(6, "Not a valid pincode")
    .required("Pincode is required"),
});

const step2FormSchema = Yup.object().shape({
  educationalDetails: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required("Required"),
        qualification: Yup.string().required("Required"),
        uniOrBoard: Yup.string().required("University or Board is required"),
        colOrSch: Yup.string().required("College or School is required"),
        gradMonthYear: Yup.date().required("Required"),
        percentage: Yup.string().required("Required"),
        course: Yup.object({
          label: Yup.string(),
          value: Yup.string(),
        }),
      })
    )
    .min(1),
});

const step3FormSchema = Yup.object().shape({
  projectsDetails: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required("Required"),
        title: Yup.string().required("Required"),
        startMonthYear: Yup.date().required("Required"),
        endMonthYear: Yup.date().required("Required"),
        description: Yup.string().required("Required"),
      })
    )
    .notRequired(),
  trainingAndCertificationDetails: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required("Required"),
        instituteName: Yup.string().required("Required"),
        courseName: Yup.string().required("Required"),
        startMonthYear: Yup.date().required("Required"),
        endMonthYear: Yup.date().required("Required"),
      })
    )
    .notRequired(),
  skillsDetails: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required("Required"),
        skillName: Yup.object({
          label: Yup.string(),
          value: Yup.string(),
        }),
        // proficiency: Yup.string().required("Required"),
      })
    )
    .notRequired(),
  preferencelocationDetails: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required("Required"),
        locationname: Yup.object({
          label: Yup.string(),
          value: Yup.string(),
        }),
      })
    )
    .notRequired(),
});

export { step1FormSchema, step2FormSchema, step3FormSchema };
